var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-row',[_c('v-col',{attrs:{"lg":"6"}},[_c('plagues',{attrs:{"isAdmin":true},on:{"rowSelected":function($event){return _vm.rowSelected1($event)}}})],1),(_vm.plID!=0)?_c('v-col',{attrs:{"lg":"6"}},[_c('cultive',{attrs:{"isAdmin":true,"PlID":_vm.plID}})],1):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }